
export function debounce(func: Function, timeout = 300) {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
}

export function parseJsonSafe<T>(str?: string, defaultValue?: T): T {
    if (!str) return defaultValue;

    try {
        return JSON.parse(str);
    } catch (e) {
        return defaultValue;
    }
}

// export function uuid() {
//     return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
//       var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
//       return v.toString(16);
//     });
// }
  